export const viewsQueryKeys = {
  views: (tableId: string) => ['views', { tableId }] as const,
  view: (tableId: string, viewId: string) => ['views', { tableId }, viewId] as const,
}
